import React from 'react';
import './QuestionNav.css';

export default function QuestionNav({ questions, currentIndex, answers, onJump }) {
  return (
    <div className="qnav">
      <div className="qnav-header">
        <span>Question Map</span>
        <div className="qnav-legend">
          <span className="legend-item answered">Answered</span>
          <span className="legend-item current">Current</span>
          <span className="legend-item unanswered">Unanswered</span>
        </div>
      </div>
      <div className="qnav-grid">
        {questions.map((q, i) => {
          const answered = answers[q.id] != null;
          const isCurrent = i === currentIndex;
          return (
            <button
              key={q.id}
              className={`qnav-btn ${answered ? 'answered' : ''} ${isCurrent ? 'current' : ''}`}
              onClick={() => onJump(i)}
              title={`Question ${i + 1}${answered ? ' (answered)' : ''}`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>
      <div className="qnav-stats">
        <div className="stat">
          <span className="stat-val">{Object.keys(answers).length}</span>
          <span className="stat-lbl">Answered</span>
        </div>
        <div className="stat">
          <span className="stat-val">{questions.length - Object.keys(answers).length}</span>
          <span className="stat-lbl">Remaining</span>
        </div>
        <div className="stat">
          <span className="stat-val">{questions.length}</span>
          <span className="stat-lbl">Total</span>
        </div>
      </div>
    </div>
  );
}
